import _extends from '@babel/runtime/helpers/esm/extends';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import styled from '@emotion/styled';
import { Box } from '@xsite-ui/common.elements';
import React, { forwardRef } from 'react';

var _templateObject;
var Link = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: pointer;\n  ", ";\n"])), function (_ref) {
  var _theme$variants, _theme$variants$link, _theme$variants2, _theme$variants2$link, _theme$variants3, _theme$variants3$link;

  var theme = _ref.theme;
  return "\n\t\ttext-decoration: ".concat((theme === null || theme === void 0 ? void 0 : (_theme$variants = theme.variants) === null || _theme$variants === void 0 ? void 0 : (_theme$variants$link = _theme$variants.link) === null || _theme$variants$link === void 0 ? void 0 : _theme$variants$link.decoration) || 'none', ";\n\t\ttransition: ").concat((theme === null || theme === void 0 ? void 0 : (_theme$variants2 = theme.variants) === null || _theme$variants2 === void 0 ? void 0 : (_theme$variants2$link = _theme$variants2.link) === null || _theme$variants2$link === void 0 ? void 0 : _theme$variants2$link.transition) || 'all 0.3s ease', ";\n\t\t\n\t\t&:hover {\n\t\t\ttext-decoration: ").concat((theme === null || theme === void 0 ? void 0 : (_theme$variants3 = theme.variants) === null || _theme$variants3 === void 0 ? void 0 : (_theme$variants3$link = _theme$variants3.link) === null || _theme$variants3$link === void 0 ? void 0 : _theme$variants3$link.decorationHover) || 'none', ";\n\t\t}\n\t");
});
Link.defaultProps = {
  variant: 'primary'
};
var link = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Link, _extends({
    "data-testid": "link"
  }, props, {
    ref: ref,
    tx: "link",
    as: "a"
  }));
});

export { link as default };
